/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Rate_MonthlyInputs */

const en_rental_rate_monthly = /** @type {(inputs: Rental_Rate_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly Rate (per night)`)
};

const es_rental_rate_monthly = /** @type {(inputs: Rental_Rate_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifa Mensual (por noche)`)
};

const fr_rental_rate_monthly = /** @type {(inputs: Rental_Rate_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif mensuel (par nuit)`)
};

const de_rental_rate_monthly = /** @type {(inputs: Rental_Rate_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatsrate (pro Nacht)`)
};

const id_rental_rate_monthly = /** @type {(inputs: Rental_Rate_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif Bulanan (per malam)`)
};

/** @type {(inputs: Rental_Rate_MonthlyInputs) => LocalizedString} */
const ja_rental_rate_monthly = en_rental_rate_monthly;

/** @type {(inputs: Rental_Rate_MonthlyInputs) => LocalizedString} */
const zh_rental_rate_monthly = en_rental_rate_monthly;

/** @type {(inputs: Rental_Rate_MonthlyInputs) => LocalizedString} */
const ar_rental_rate_monthly = en_rental_rate_monthly;

/** @type {(inputs: Rental_Rate_MonthlyInputs) => LocalizedString} */
const it_rental_rate_monthly = en_rental_rate_monthly;

/** @type {(inputs: Rental_Rate_MonthlyInputs) => LocalizedString} */
const ru_rental_rate_monthly = en_rental_rate_monthly;

/** @type {(inputs: Rental_Rate_MonthlyInputs) => LocalizedString} */
const pt_rental_rate_monthly = en_rental_rate_monthly;

/** @type {(inputs: Rental_Rate_MonthlyInputs) => LocalizedString} */
const ko_rental_rate_monthly = en_rental_rate_monthly;

/**
* | output |
* | --- |
* | "Monthly Rate (per night)" |
*
* @param {Rental_Rate_MonthlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_rate_monthly = /** @type {((inputs?: Rental_Rate_MonthlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Rate_MonthlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_rate_monthly(inputs)
	if (locale === "es") return es_rental_rate_monthly(inputs)
	if (locale === "fr") return fr_rental_rate_monthly(inputs)
	if (locale === "de") return de_rental_rate_monthly(inputs)
	if (locale === "ja") return ja_rental_rate_monthly(inputs)
	if (locale === "zh") return zh_rental_rate_monthly(inputs)
	if (locale === "ar") return ar_rental_rate_monthly(inputs)
	if (locale === "id") return id_rental_rate_monthly(inputs)
	if (locale === "it") return it_rental_rate_monthly(inputs)
	if (locale === "ru") return ru_rental_rate_monthly(inputs)
	if (locale === "pt") return pt_rental_rate_monthly(inputs)
	return ko_rental_rate_monthly(inputs)
});